var _style, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadio0Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.657 6.145",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n:root {\n", /*#__PURE__*/React.createElement("style", null, "\n:root {\n--black-300: #ced3df;\n--black-400: #B1BBCD;\n--warning: #d42c2c;\n--stroke: var(--black-400);\n--knob: var(--black-300);\n}\n"), "\n}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad-accent-tight",
    x1: 0,
    y1: 4.498,
    x2: 27.517,
    y2: 4.498,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.108 .254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.033,
    stopColor: "var(--stroke)",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "var(--stroke)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "var(--stroke)",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "track"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.108 3.694H.114c1.058 0 1.19.53 1.72 1.058.337.338.926 1.06 2.513 1.06 1.588 0 2.117-.663 2.514-1.06s.661-1.058 1.72-1.058H26.41",
    fill: "none",
    stroke: "url(#grad-accent-tight)",
    strokeWidth: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "knobs"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.449,
    cy: 2,
    r: 1.8,
    fill: "transparent",
    stroke: "var(--warning)",
    strokeWidth: 0.3,
    "data-knob": 0,
    "data-layer": "ring"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.449,
    cy: 2,
    r: 1,
    fill: "var(--warning)",
    "data-knob": 0,
    "data-layer": "inner"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.328,
    cy: 1.6,
    r: 1,
    fill: "var(--knob)",
    "data-knob": 1,
    "data-layer": "ring"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.207,
    cy: 1.6,
    r: 1,
    fill: "var(--knob)",
    "data-knob": 2,
    "data-layer": "ring"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio0Light);
export default __webpack_public_path__ + "static/media/radio0-light.22d2b6fe065f1505bb1cd20fc3f38d25.svg";
export { ForwardRef as ReactComponent };